import axios from "axios";
import config from "../../config/constants";
import { toastr } from 'react-redux-toastr';
import store from '../../containers/App/store';
import info from "../../config/messages";
import {loadProcessToken } from "../actions/index";

export const LOAD_DASHBOARD = "LOAD_DASHBOARD";

export const loadDashboard = (collection_id, scope) => {
    let token = loadProcessToken();
    let query_string ='';
    if (collection_id){
            query_string = '/' +collection_id;
    }
    let url = config.API_URL + 'ai4ai/dashboard' +query_string;
    return (dispatch, getState) => {
        axios.get(url).then(({ data }) => {
            dispatch({
                type: LOAD_DASHBOARD,
                payload: data.data
            });
        }).catch(function (error) {
            console.log(error);
            if (!error.response) {
              toastr.error("Network Error:", error);
            } else if(error.response.data){
               if(error.response.data.error){
                toastr.error("Error", error.response.data.error);
               } else{
                  toastr.error("Unknown Error in loading dashboard", "Please refer the console logs for more details on the error.");
               }
            }else{
              if (error.response) {
                  toastr.error("Error", error.response);
              } else {
                  toastr.error("Unknown Error in loading asset types", "Please refer the console logs for more details on the error.");
              }
            }
        });
    }
}
